export class ProtoValidationError extends Error {}
